var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoToLiveArrow = function SvgGoToLiveArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7 1a1 1 0 0 1 1.414 0l6.293 6.293a1 1 0 0 1 0 1.414L8.414 15A1 1 0 0 1 7 13.586L11.586 9H1a1 1 0 1 1 0-2h10.586L7 2.414A1 1 0 0 1 7 1",
    clipRule: "evenodd"
  })));
};
export default SvgGoToLiveArrow;